import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";
import { useSelector } from "react-redux";

import * as SearchSelectors from "@/redux/modules/value/search/search.selectors";
import { SearchComponent } from "@/utils/search/types/searchComponent";

import { SEARCH_CONTENT_ID } from "../../../numberOfHits/numberOfHits.config";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const hasProductResults = useSelector(
        SearchSelectors.hasResults(SearchComponent.PRODUCT_NUMBER_OF_HITS)
    );

    const hasSelectedProductFacets = useSelector(
        SearchSelectors.hasSelectedFacets(SearchComponent.PRODUCT_FACETS)
    );

    const expanded = !(hasProductResults || hasSelectedProductFacets);

    return (
        <article
            id={SEARCH_CONTENT_ID}
            className={cn("tw:col-[1/3]", {
                "tw:row-[1/3]": expanded,
                "tw:lg:col-[2/3]": !expanded
            })}
        >
            {children}
        </article>
    );
};

export { Base };
